<template>
	<div class="view contentBody">
		<div class="mb15">
			<el-form :inline="true" :model="listData" class="form-inline">
				<el-form-item label="活动名称">
					<el-input class="mr10 w200" v-model="listData.title" size="medium" placeholder="请填写"></el-input>
				</el-form-item>
				<el-form-item label="模板分类">
					<el-select class="mr10 w200" v-model="listData.tmp_type" size="medium" placeholder="请选择">

						<el-option v-for="item in tmp_type_conf" :key="item.value" :label="item.name"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="适用节日">
					<el-select class="mr10 w200" v-model="listData.festival_type" size="medium" placeholder="请选择">
						<el-option v-for="item in festival_type_conf" :key="item.value" :label="item.name"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="适用行业">
					<el-select class="mr10 w130" v-model="listData.industry_type" size="medium" placeholder="请选择">
						<el-option v-for="item in industry_type_conf" :key="item.value" :label="item.name"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="活动类别">
					<el-select class="mr10 w130" v-model="listData.activity_type" size="medium" placeholder="请选择">
						<el-option v-for="item in activity_type_conf" :key="item.value" :label="item.name"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button-group>
						<el-button type="primary" size="medium" @click="onSearch">开始检索</el-button>
						<el-button size="medium" @click="onReset">重置检索</el-button>
						<el-button size="medium" @click="goList">进入列表</el-button>
					</el-button-group>
				</el-form-item>
			</el-form>
		</div>


		<div class="table_wrap mb15 table_template">
			<!-- <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="template_name" label="使用模板" ></el-table-column>
        <el-table-column prop="title" label="活动名称" >
          <div slot-scope="scope" >
            <span :title="scope.row.title ">{{scope.row.title | ellipsis}}</span>
          </div>
        </el-table-column>
        <el-table-column prop="start_time_text" label="开始时间" >
          <div slot-scope="scope" >
            <span>{{scope.row.start_time_text.split(" ")[0]}}</span>
            <br>
            <span>{{scope.row.start_time_text.split(" ")[1]}}</span>
          </div>
        </el-table-column>
        <el-table-column prop="end_time_text" label="结束时间" >
          <div slot-scope="scope" >
            <span>{{scope.row.end_time_text.split(" ")[0]}}</span>
            <br>
            <span>{{scope.row.end_time_text.split(" ")[1]}}</span>
          </div>
        </el-table-column>
        <el-table-column label="活动状态">
          <template slot-scope="scope">
                <el-switch :ref="`switch${scope.$index}`"
                v-model="scope.row.status" :active-value="1" :inactive-value="2"
                active-color="#2AA3F8"
                inactive-color="#dcdfe6"
                @change="onSetStatus($event,scope.row.activity_id,scope.row,scope.$index)"
                >
              </el-switch>

          </template>
        </el-table-column>
        <el-table-column prop="join_num" label="参与人数" align="center"></el-table-column>
        <el-table-column prop="buy_num" label="购买人数" align="center"></el-table-column>
        <el-table-column prop="repost_num" label="转发总量" align="center"></el-table-column>
        <el-table-column prop="click_num" label="曝光总量" align="center"></el-table-column>
        <el-table-column prop="create_time_text" label="创建时间" >
          <div slot-scope="scope" >
            <span>{{scope.row.create_time_text.split(" ")[0]}}</span>
            <br>
            <span>{{scope.row.create_time_text.split(" ")[1]}}</span>
          </div>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="118">
          <template slot-scope="scope">
            <el-button type="primary" size="small" icon="el-icon-edit" @click="publish('open', scope.row.activity_id, scope.row.tmp_id)">操作菜单</el-button>
          </template>
        </el-table-column>
      </el-table> -->
			<template v-for='(item,index) in template_list'>
				<div class="temp_item" :key='index'>
					<p class="temp_mask">{{item.activity_type_text}}</p>
					<p class="temp_right" @click="onPreview(index)">预览</p>
					<div class="temp_item_img">
						<img :src="item.isPreview?item.previewImg:item.cover_img" alt="" />
					</div>
					<div class="temp_item_txt">
						<p class="temp_item_txt_p">{{item.title}}</p>
						<el-button type="primary" size="mini"
							@click="publish(item.id, item.activity_type, item.activity_id)">制作</el-button>
					</div>
				</div>
			</template>
		</div>
		<div class="pag_wrap">
			<el-pagination background :page-size="page.page_size" :current-page="page.current_page"
				layout="total, prev, pager, next" :total="page.total_rows"
				@current-change="pageIndexChange"></el-pagination>
		</div>

	</div>
</template>

<script>
	import {
		pagination
	} from "@/util/util.js";
	import api from "@/api.js";
	export default {
		name: "templateList",

		filters: { //限制文本显示字数,超出部分用...代替
			ellipsis(value) {
				if (!value) return ''
				if (value.length > 10) {
					return value.slice(0, 10) + '...'
				}
				return value
			},
		},
		data() {
			return {
				template_list: [],
				tmp_type_conf: [], //模板分类筛选条件
				festival_type_conf: [], //适用节日筛选条件
				industry_type_conf: [], //适用行业筛选条件
				activity_type_conf: [], //活动类别筛选条件
				page: {
					current_page: pagination.current_page,
					page_size: pagination.page_size,
					total_rows: pagination.total_rows
				},
				listData: {
					title: "",
					tmp_type: 0,
					festival_type: 0,
					industry_type: 0,
					activity_type: 0,
					page: 1
				},
				createDateTime: [],
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				showQrcode: false,
				showReview: false,
				codeinfo: {},
				checkInfo: {}
			}
		},
		mounted() {
			this.initFn(1);
		},
		methods: {
			//预览
			async onPreview(index){
				let list = this.template_list;
				// list.forEach(async (item, i) => {
				// 	if (index == i) {
				// 		if(item.previewImg){
				// 			item.isPreview = item.isPreview? 0:1;
				// 		}else{
				// 			let result = await this.getShareInfo(item.id)
				// 			console.log(result,'result')
				// 			if(result){
				// 				item.isPreview = item.isPreview? 0:1;
				// 				item.previewImg = result
				// 			}else{

				// 			}
				// 		}
				// 	}
				// })
				for(let i=0;i<list.length;i++){
					if (index == i) {
						if(list[i].previewImg){
							list[i].isPreview = list[i].isPreview? 0:1;
						}else{
							if(!list[i].activity_id || list[i].activity_id == 0){
								 this.$message.warning("暂无预览");
								 return
							}
							let result = await this.getShareInfo(list[i].activity_id)
							console.log(result,'result')
							if(result){
								list[i].isPreview = list[i].isPreview? 0:1;
								list[i].previewImg = result
							}else{

							}
						}
					}
				}
				this.template_list = list;
				this.$set(this.template_list, index, list[index])
				console.log(list,'list',this.template_list)
			},
			getShareInfo(activity_id) {
				return new Promise((reject,refuse)=>{
					this.axios
					.post(api.getShareInfo, {activity_id: activity_id})
					.then(response => {
						if (response.data.code == 0) {
							reject(response.data.result.qrcode)
						}else{
							refuse(false)
						}
					})
					.catch(() => {}); 
				})
				
			},
			// 初始化数据请求
			initFn(num) {
				this.axios
					.post(api.templateList, this.listData)
					.then(response => {
						if (response.data.code == 0) {
							this.template_list = response.data.result.list;
							if (num) {
								this.activity_type_conf = response.data.result.activity_type_conf;
								this.festival_type_conf = response.data.result.festival_type_conf;
								this.industry_type_conf = response.data.result.industry_type_conf;
								this.tmp_type_conf = response.data.result.tmp_type_conf;
							}

							response.data.page.current_page = parseInt(response.data.page.current_page);
							this.page = response.data.page;
						}
					})
					.catch(() => {});
			},
			// 开始检索
			onSearch() {
				this.initFn();
			},
			// 重置检索
			onReset() {
				this.listData.title = "";
				this.listData.tmp_type = 0;
				this.listData.festival_type = 0;
				this.listData.industry_type = 0;
				this.listData.activity_type = 0;
				this.initFn();
			},
			//进入列表
			goList(){
				this.$router.replace({path: 'tkAnalytics'});
			},
			// 分页
			pageIndexChange(pageindex) {
				this.listData.page = pageindex;
				this.initFn(1);
			},
			// 选择开始结束时间
			onChangeDate(value) {
				if (value == null) {
					this.listData.start_time = ''
					this.listData.end_time = ''
				} else {
					this.listData.start_time = value[0];
					this.listData.end_time = value[1];
				}

			},
			/**
			 * option 按钮事件
			 * add    创建活动
			 * edit   编辑活动
			 * open   操作菜单
			 */
			publish(tid, activity_type, activity_id) {
				console.log('创建活动', activity_type)
				this.$router.push({
					name: "addOrEditTuoke",
					query: {
						'tid': tid,
						'activity_type': activity_type,
						'id': activity_id
					}
				});
			},


		}
	}
</script>
<style scoped>
	.temp_right{
		position: absolute;
		right: 0;
		top: 0;
		background: rgba(0, 0, 0, .5);
		color: #fff;
		font-size: 10px;
		padding: 5px;
	}
</style>